const scrollToSection = (id: string) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};

export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Split background */}
      <div className="absolute inset-0 flex">
        {/* Left: 建てサポ */}
        <div className="relative w-1/2 h-full">
          <img
            src="https://public.readdy.ai/ai/img_res/07205260e6f4a90999cfa7712efed8d9.jpg"
            alt="建てサポ事業"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-[#1e3a70]/45"></div>
        </div>
        {/* Right: 整理収納 */}
        <div className="relative w-1/2 h-full">
          <img
            src="https://readdy.ai/api/search-image?query=beautifully%20organized%20bright%20japanese%20home%20interior%20living%20room%20tidy%20clean%20minimalist%20shelving%20warm%20natural%20light%20neatly%20arranged%20items%20cozy%20family%20space%20cheerful%20modern%20interior%20design%20inviting%20atmosphere&width=960&height=1080&seq=hero-right2&orientation=portrait"
            alt="整理収納事業"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-orange-600/35"></div>
        </div>
        {/* Center divider glow */}
        <div className="absolute inset-y-0 left-1/2 -translate-x-1/2 w-px bg-white/30"></div>
      </div>

      {/* Subtle top/bottom gradient for text readability */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/25 pointer-events-none"></div>

      <div className="relative z-10 w-full text-center px-6 pt-20">
        <p className="text-white/80 text-sm font-medium tracking-widest uppercase mb-5">
          住まいと暮らしのトータルサポート
        </p>
        <h1 className="text-white font-bold leading-tight mb-6 drop-shadow-md" style={{ fontFamily: 'Noto Serif JP', fontSize: 'clamp(2rem, 5vw, 3.5rem)' }}>
          「住まい」と「暮らし」を、<br />
          <span className="text-white">専門家</span>がともに支える
        </h1>
        <p className="text-white/90 text-lg max-w-2xl mx-auto mb-12 leading-relaxed drop-shadow">
          賃貸併用住宅の建築コンサルティングから、<br className="hidden md:block" />
          子育て・介護世帯向けの整理収納サービスまで。<br className="hidden md:block" />
          あなたの理想の暮らしを実現するパートナーです。
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => scrollToSection('tatesapo')}
            className="group flex items-center justify-center gap-3 bg-[#1e3a70] hover:bg-[#162e5c] text-white font-medium px-8 py-4 rounded-full transition-all cursor-pointer whitespace-nowrap shadow-lg"
          >
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-building-2-line text-xl"></i>
            </div>
            建てサポ事業を見る
          </button>
          <button
            onClick={() => scrollToSection('organizing')}
            className="group flex items-center justify-center gap-3 bg-orange-500 hover:bg-orange-600 text-white font-medium px-8 py-4 rounded-full transition-all cursor-pointer whitespace-nowrap shadow-lg"
          >
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-home-heart-line text-xl"></i>
            </div>
            整理収納事業を見る
          </button>
        </div>

        <button
          onClick={() => scrollToSection('tatesapo')}
          className="mt-16 text-white/60 flex flex-col items-center gap-2 mx-auto cursor-pointer hover:text-white/90 transition-colors animate-bounce"
        >
          <span className="text-xs tracking-widest">SCROLL</span>
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-arrow-down-line text-lg"></i>
          </div>
        </button>
      </div>
    </section>
  );
}
